import { connectedStore } from '../../store';
import replaceElementAction from '../actions/replace-element';
import { USED_ACTION_CREATOR } from '../constants/symbols';

const replaceElement = (element, targetElementId, options) => {
  const store = connectedStore.get();
  store.dispatch(replaceElementAction(element, targetElementId, options));
};

replaceElement[USED_ACTION_CREATOR] = replaceElementAction;

export default replaceElement;
